export enum RouteId {
    // Administration
    USERS,
    USERS_COLLABORATOR,
    USERS_DRIVER,
    USERS_EXPLOIT,
    STATIONS,
    TERMINALS,
    TERMINALS_INFOS,
    TERMINALS_CONTACTS,
    CLIENTS,
    CLIENTS_INFOS,
    CLIENTS_CONTACTS,
    CLIENTS_STATIONS,
    CLIENTS_CONTRATS,
    CONTRAT_CLIENT,
    CONTRAT_CLIENT_INFO,
    CONTRAT_CLIENT_AMENDMENTS,
    CARRIERS,
    CARRIERS_INFOS,
    CARRIERS_CONTACTS,
    CARRIERS_TERMINALS,
    CARRIERS_VEHICLES,
    CARRIERS_DRIVERS,
    CARRIERS_OPERATORS,
    CARRIERS_CONTRATS,
    SETTINGS,
    SETTINGS_TICGN,
    SETTINGS_SECTION,
    MOBILE,
    DRIVER_DAY,
    DRIVER_NEXT_WEEK,
    DRIVER_LAST_WEEK,
    DRIVER_DELIVERY,

    //Logistique
    TANKS,
    DELIVERIES,
    PLANNING,

    //Finances 
    CHARGES_SWAP,
    PREINVOICE_CARRIER,
    INVOICE,

    // Station
    STATION_SAFETY_DOCUMENTS



}
